/* eslint-disable prettier/prettier */
import localize from '../../localize';

export default {
  'taxonomies.Apex-areas': localize('refinementKommun')
    ? localize('refinementKommun')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};
